export enum PostCampaignCardStatus {
  BEFORE_APPLICATION = 'BEFORE_APPLICATION',
  DEDUCT = 'DEDUCT',
  DRAFT = 'DRAFT',
  NEAR_DUE = 'NEAR_DUE',
  SUBMITTED = 'SUBMITTED',
}

export enum PostCampaignStatus {
  // 신청완료
  APPLY_SUCCESS = 'APPLY_SUCCESS',
  // 차감
  DEDUCT = 'DEDUCT',
  // 이탈
  DEVIATION = 'DEVIATION',
  // 적립완료
  EARNING_SUCCESS = 'EARNING_SUCCESS',
  // 미제출
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  // 반려
  REJECT = 'REJECT',
  // 제출완료
  SUBMITTED = 'SUBMITTED',
}
